module.exports = __webpack_public_path__ + "img/9.65a64d36.jpg";